import React, { useEffect, useContext, useState } from 'react';

import {
    Paper,
    Avatar,
    Table,
    TableHead,
    TableBody,  
    TableRow,
    TableCell,      
    Typography,
    Hidden,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    LinearProgress
} from '@material-ui/core';

import { AssignmentListProvider, AssignmentListContext } from './AssignmentListContext';
import { NavContext, NavRoutes, FetchContext, ApiRoutes } from '../../../contexts';
import PeopleAltIcon from '@material-ui/icons/PeopleAltOutlined';

import { makeStyles } from '@material-ui/core/styles';
import { SearchUser } from '../../../common';
const useStyles = makeStyles((theme) => ({
    newAssignment: {
        marginBottom: '40px'
    },
    root: {
        width: '100%',
        overflow: 'hidden',
    },
    header: {
        fontSize: '1rem'
    },
    icon: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    owner: {
        marginLeft: '10px'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    deleteButton: {
        marginLeft: '20px'
    },
    table: {

    }
}));

const PageContent = (props) => {    
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
    const { fetchAuthorized } = useContext(FetchContext);
    const classes = useStyles();

    const {
        navigateTo
    } = useContext(NavContext)

    const {
        state,
        getProjectTeams,
        deleteTeamAsync
	} = useContext(AssignmentListContext);

	const {
        isLoadingTeams,
        projectTeams,
        isDeleted
    } = state;

    useEffect(() => {
        addBreadcrumbToken("Assignments list");
        getProjectTeams();
    }, [])

    useEffect(() => {
        if (isDeleted)
            getProjectTeams();
    }, [isDeleted])

    return (
        <div>
            {isLoadingTeams ?
            <LinearProgress color="primary" /> :
            <>
                <Button
                    className={classes.newAssignment}
                    color="primary"
                    size="small"
                    variant="contained"
                    onClick={() => navigateTo(NavRoutes.Admin.EditOwnerAssignment, [0])}
                >
                    New assignment
                </Button>
                <Paper className={classes.root}>
                    <Table className={classes.table} arial-label="role table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.header}>Owner</TableCell>
                                <TableCell className={classes.header}>Code</TableCell>
                                <TableCell className={classes.header} align="center">Project managers</TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {projectTeams &&
                            projectTeams.items &&
                            projectTeams.items.map((team, index) => 
                                <TableRow hover key={index}>
                                    <TableCell component="th" scope="row">
                                        <div className={classes.icon}>
                                            <Avatar aria-label="recipe" className={classes.avatar}>
                                                <PeopleAltIcon />
                                            </Avatar>                                
                                            <Typography className={classes.owner}>
                                                {team.owner.displayName}
                                            </Typography>
                                        </div>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <Typography>
                                            {team.code}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography>
                                            {
                                                team.projectManagers[0] &&
                                                <span>
                                                    {team.projectManagers[0].displayName}
                                                </span>
                                            }
                                            {
                                                team.projectManagers[1] &&
                                                <span>
                                                    , {team.projectManagers[1].displayName}
                                                </span>
                                            }
                                            {
                                                team.projectManagers[2] && ", ..."
                                            }
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <div className={classes.buttonContainer}>
                                            <Button 
                                                color="primary"
                                                size="small"
                                                variant="contained"
                                                onClick={() => navigateTo(NavRoutes.Admin.EditOwnerAssignment, [team.projectTeamId])}
                                            >
                                                Edit
                                            </Button>
                                            <Button
                                                className={classes.deleteButton}
                                                color="secondary"
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure you want to delete these assignments?"))
                                                        deleteTeamAsync(team.projectTeamId);
                                                }}
                                            >
                                                Remove assignments
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>
            </>
            }
        </div>
    );
}

export const AssignmentListPage = () => {

    return (
        <AssignmentListProvider>
            <PageContent />
        </AssignmentListProvider>
    );
}